import useRetrieveData from 'global/hooks/useRetrieveData';

export const REALM_PHOTO_INCLUDES = ['supersets', 'realm', 'images'];

// How long a cached list is reused before refetching (catches other users' uploads).
const CACHE_MINUTES = 30;

// One shared, cached /realm-photos request per assessment. The Photos tab and the
// score photo pickers use the exact same params so they share one cache entry;
// filter the result client-side instead of adding params.
// Writes to /realm-photos drop the cache in sendData (destroyRealmPhotosCache), so
// the next mount refetches while anything already on screen keeps its in-place edits.
export const useAssessmentRealmPhotos = (assessmentId, opts = {}) =>
  useRetrieveData(
    { url: '/realm-photos' },
    {
      // without an id the request would be unfiltered (undefined means "don't wait", so coerce)
      waitFor: !!assessmentId,
      useCache: { reload: CACHE_MINUTES },
      build: ['realmPhotos'],
      params: {
        filter: { assessment_id: assessmentId },
        include: REALM_PHOTO_INCLUDES.join(','),
      },
      ...opts,
    },
    [assessmentId]
  );

export default useAssessmentRealmPhotos;
